import { render, staticRenderFns } from "./JinJi.vue?vue&type=template&id=48b556f2&scoped=true"
import script from "./JinJi.vue?vue&type=script&lang=js"
export * from "./JinJi.vue?vue&type=script&lang=js"
import style0 from "./JinJi.vue?vue&type=style&index=0&id=48b556f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b556f2",
  null
  
)

export default component.exports